import React from "react";

const SVG = ({ className }) => {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9751 11.6098L19 11.6003V16.0333C19 16.5672 18.5529 17 18.0013 17C17.7364 17 17.4824 16.8982 17.2951 16.7169L15.0052 14.5003H2.99607C1.34139 14.5003 0 13.2019 0 11.6003V2.90007C0 1.29841 1.34139 0 2.99607 0H15.979C17.6337 0 18.9751 1.29841 18.9751 2.90007V11.6003C18.9751 11.6034 18.9751 11.6066 18.9751 11.6098Z"
        fill="#FAAA31"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.49413 8.70012C3.66679 8.70012 2.99609 8.05092 2.99609 7.25008C2.99609 6.44925 3.66679 5.80005 4.49413 5.80005C5.32147 5.80005 5.99216 6.44925 5.99216 7.25008C5.99216 8.05092 5.32147 8.70012 4.49413 8.70012ZM9.48757 8.70012C8.66023 8.70012 7.98954 8.05092 7.98954 7.25008C7.98954 6.44925 8.66023 5.80005 9.48757 5.80005C10.3149 5.80005 10.9856 6.44925 10.9856 7.25008C10.9856 8.05092 10.3149 8.70012 9.48757 8.70012ZM14.481 8.70012C13.6537 8.70012 12.983 8.05092 12.983 7.25008C12.983 6.44925 13.6537 5.80005 14.481 5.80005C15.3084 5.80005 15.9791 6.44925 15.9791 7.25008C15.9791 8.05092 15.3084 8.70012 14.481 8.70012Z"
        fill="white"
      />
    </svg>
  );
};

export default SVG;
